import { PageId } from 'constants/pages'

export const enum PageIdWoofzHlwn70 {
  SUBSCRIPTIONS_PAGE_HLWN_70 = PageId.SUBSCRIPTIONS_PAGE_HLWN_70,
  CHAT_UPSELL_HLWN_70 = PageId.CHAT_UPSELL_HLWN_70,
  UPSELL_HLWN_70 = PageId.UPSELL_HLWN_70,
  DOWNLOAD_HLWN_70 = PageId.DOWNLOAD_HLWN_70,
  ACCOUNT_NOVE8 = PageId.ACCOUNT_NOVE8,
}
